var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dotsWrapper",style:(_vm.wrapperStyles)},[_c('div',{staticClass:"spinner",style:(_vm.spinnerStyles)},[_c('div',{staticClass:"bounce1",style:(_vm.dotsStyles)}),_c('div',{staticClass:"bounce2",style:(_vm.dotsStyles)}),_c('div',{staticClass:"bounce3",style:(_vm.dotsStyles)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }